const yodleeAutoScript = (() => {
    const inputMethods = ['auto', 'manual'];
    let promiseResolve;
    const yodleeAutoDefaultConfig = {
        terms_and_condition_accepted: false
    };
    const widgetPromise = new Promise((resolve, reject) => {
        promiseResolve = resolve;
    });

    /**
     * main : returning yodlee HTML with config
     *
     * @author Nitesh <nitesh.meena@biz2credit.com>
     *
     * @param obj object
     */
    const main = (obj) => {
        initScript.toggleLoader(true);
        Object.assign(yodleeAutoDefaultConfig, obj);
        yodleeAutoDefaultConfig.security_option = !!yodleeAutoDefaultConfig.body.security ? yodleeAutoDefaultConfig.body.security : {};
        yodleeAutoDefaultConfig.slugs_flag = !!yodleeAutoDefaultConfig.slugs;
        yodleeAutoDefaultConfig.slugs = yodleeAutoDefaultConfig.slugs || {};
        initOptions(yodleeAutoDefaultConfig.widget_service_api);
        const yodleeAutoHtml = (!!yodleeAutoDefaultConfig.body['yodleeAuto'] && !!yodleeAutoDefaultConfig.body['yodleeAuto'].html) ? yodleeAutoDefaultConfig.body['yodleeAuto'].html : {};
        const options = initScript.methodWiseOption(yodleeAutoDefaultConfig.options.yodlee.method, {
            url: yodleeAutoDefaultConfig.options.yodlee.url,
            data: yodleeAutoHtml
        }, yodleeAutoDefaultConfig.security_option);


        HttpRequest(options, res => {
            res = typeof res === "string" ? res : responseV2Interceptor(res, yodleeAutoDefaultConfig.slugs['yodlee-auto'], false);
            initScript.getHTMLElementByDelimiter(yodleeAutoDefaultConfig.body['yodleeAuto'].class).append(res);
            getIFrame();
            bindTermsAndConditionEmitters();
        });
    };

    /**
     * getIFrame : open yodlee model
     *
     * @author Nitesh <nitesh.meena@biz2credit.com>
     *
     */
    const getIFrame = () => {
        const options = initScript.methodWiseOption(yodleeAutoDefaultConfig.options.openYodleeModel.method, {
            url: yodleeAutoDefaultConfig.options.openYodleeModel.url,
        }, yodleeAutoDefaultConfig.security_option);
        HttpRequest(options, res => {
            res = responseV2Interceptor(res, yodleeAutoDefaultConfig.slugs.openYodleeModel);
            if (!!res["fast_link_url"] || res.code !== 400) {
                bindTermsAndConditionEmitters();
                res = responseInterceptor(res);
                yodleeAutoDefaultConfig.yodleeBody = !!res["fast_link_url"] ? res : res.data;
                bindEmitters();
                initScript.disableElementByProp('#yodleeAutoBtnLinkAccount', false);
                initScript.toggleLoader(false);
            }
        });
    };

    /**
     * initOptions : initializing option config
     *
     * @author Nitesh <nitesh.meena@biz2credit.com>
     *
     * @param API_URL string
     */
    const initOptions = (API_URL) => {
        yodleeAutoDefaultConfig.options = {
            yodlee: {
                url: !!yodleeAutoDefaultConfig['widget_service_slug_url'] ? yodleeAutoDefaultConfig['widget_service_slug_url'] : getV2URL(API_URL, "yodlee-auto", yodleeAutoDefaultConfig.slugs),
                method: "POST",
            },
            yodleeTransactionIds: {
                url: getV2URL(API_URL, "yodleeTransactionIds", yodleeAutoDefaultConfig.slugs),
                method: 'GET',
            },
            submitYodleeForm: {
                url: getV2URL(API_URL, "submitYodleeForm", yodleeAutoDefaultConfig.slugs),
                method: 'POST',
            },
            classifyDocs: {
                url: getV2URL(API_URL, "classify-docs", yodleeAutoDefaultConfig.slugs),
                method: 'POST'
            },
            openYodleeModel: {
                // url: API_URL + '/openYodleeModel' + '?internal=true',
                url: getV2URL(API_URL, "openYodleeModel", yodleeAutoDefaultConfig.slugs),
                method: 'GET'
            }
        };
    };

    /**
     * appendCSS : appending CSS with yodleeConfigObj
     *
     * @author Nitesh <nitesh.meena@biz2credit.com>
     *
     */
    const appendCSS = () => {
        if (yodleeAutoDefaultConfig.body.yodleeAuto.hasOwnProperty('css')) {
            const cssClassKeys = Object.keys(yodleeAutoDefaultConfig.body.yodleeAuto.css);
            for (let i = 0; i < cssClassKeys.length; ++i) {
                const css = initScript.getStyleString(yodleeAutoDefaultConfig.body.yodleeAuto.css[cssClassKeys[i]]);
                initScript.getHTMLElementByDelimiter(cssClassKeys[i]).attr('style', css);
            }
        }
    };

    /**
     * openYodleeAutoModal : open-yodlee-modal
     *
     * @author Nitesh <nitesh.meena@biz2credit.com>
     *
     */
    const openYodleeAutoModal = () => {
        if (!yodleeAutoDefaultConfig.yodleeBody) return;
        hideTermsAndConditionModal();
        yodleeAutoDefaultConfig.yodleeAutoModal.show();
        $('body').addClass('modal-open');

        document.getElementsByName('app')[0].value = yodleeAutoDefaultConfig.yodleeBody.app_id;
        document.getElementsByName('rsession')[0].value = yodleeAutoDefaultConfig.yodleeBody['user_token'];
        document.getElementsByName('token')[0].value = yodleeAutoDefaultConfig.yodleeBody['fast_link_token'];

        if(yodleeAutoDefaultConfig.yodleeBody['version'] && yodleeAutoDefaultConfig.yodleeBody['version'] == "v4"){
            document.getElementsByName('jwtToken')[0].value = yodleeAutoDefaultConfig.yodleeBody['jwt_token'];
            document.getElementsByName('extraParams')[0].value = "configName="+yodleeAutoDefaultConfig.yodleeBody['config_name']+"&isIFrameMounted=true";
            document.getElementsByName('token')[0].remove();
        }
        else{
            if(document.getElementsByName('jwtToken')[0]){
                document.getElementsByName('jwtToken')[0].remove();
            }
        }
        const yodleeForm = document.getElementById('yodlee_form');
        yodleeForm.action = yodleeAutoDefaultConfig.yodleeBody['fast_link_url'];
        yodleeForm.submit();
    };

    /**
     * yodleeManualValidatorSuccess : go on yodlee manual after success validation
     *
     * @author Nitesh <nitesh.meena@biz2credit.com>
     *
     */
    const yodleeManualValidatorSuccess = () => {
        yodleeManualScript.main(yodleeAutoDefaultConfig);
    };

    /**
     * yodleeAutoValidatorSuccess : yodleeAutoValidatorSuccess
     *
     * @author Nitesh <nitesh.meena@biz2credit.com>
     *
     */
    const yodleeAutoValidatorSuccess = () => {
        openYodleeAutoModal();
    };

    /**
     * yodleeAutoValidator : yodlee auto validator with rerms and condition
     *
     * @author Nitesh <nitesh.meena@biz2credit.com>
     *
     */
    const yodleeAutoValidator = () => {
        document.getElementById("doneMessageID").innerHTML = '';
        if (initScript.getObjectValueByString(yodleeAutoDefaultConfig, "body.yodleeAuto.html.terms_and_condition")  && !!yodleeAutoDefaultConfig.body.yodleeAuto.html["terms_and_condition"].flag) showTermsAndConditionModal();
        else yodleeAutoValidatorSuccess();
    };

    /**
     * showTermsAndConditionModal : show terms and condition modal
     *
     * @author Nitesh <nitesh.meena@biz2credit.com>
     *
     */
    const showTermsAndConditionModal = () => {
        initScript.addCSSAtTargetIdentifier('yodleeManualTermsConditionSuccess', { "display": "block" });
    };

    /**
     * hideTermsAndConditionModal : hide terms and condition modal
     *
     * @author Nitesh <nitesh.meena@biz2credit.com>
     *
     */
    const hideTermsAndConditionModal = () => {
        initScript.addCSSAtTargetIdentifier('yodleeManualTermsConditionSuccess', {
            display: 'none'
        });
    };

    /**
     * showTermsAndConditionRequiredFieldError : show terms and condition required field error
     *
     * @author Nitesh <nitesh.meena@biz2credit.com>
     *
     */
    const showTermsAndConditionRequiredFieldError = () => {
        initScript.addCSSAtTargetIdentifier('termsAndConditionRequiredFieldError', {
            display: 'block'
        });
    };

    /**
     * hideTermsAndConditionRequiredFieldError : hide terms and condition required field error
     *
     * @author Nitesh <nitesh.meena@biz2credit.com>
     *
     */
    const hideTermsAndConditionRequiredFieldError = () => {
        initScript.addCSSAtTargetIdentifier('termsAndConditionRequiredFieldError', {
            display: 'none'
        });
    };

    /**
     * cancelYodleeTransaction : cancel Yodlee Transaction
     *
     * @author Nitesh <nitesh.meena@biz2credit.com>
     *
     */
    const cancelYodleeTransaction = () => {
        yodleeAutoDefaultConfig.yodleeAutoModal.hide();
        initScript.getTargetIdentifierElement('body')[0].classList.remove('modal-open');
        yodleeAutoDefaultConfig.yodlee_error_modal_header.css('display', 'none');
    };

    /**
     * bindEmitters : binding event emitters
     *
     * @author Nitesh <nitesh.meena@biz2credit.com>
     *
     */
    const bindEmitters = () => {
        if (!yodleeAutoDefaultConfig.yodleeBody) return alert("Something went wrong with yodlee.\nPlease try again.");
        yodleeAutoDefaultConfig.yodleeManualBtnContinue = initScript.getHTMLElementByDelimiter('yodleeManualBtnContinue', '#');
        yodleeAutoDefaultConfig.yodleeAutoBtnLinkAccount = initScript.getHTMLElementByDelimiter('yodleeAutoBtnLinkAccount', '#');
        yodleeAutoDefaultConfig.yodleeAutoBtnLinkContinue = initScript.getHTMLElementByDelimiter('yodleeAutoBtnLinkContinue', '#');
        yodleeAutoDefaultConfig.submitYodleeTransaction = initScript.getHTMLElementByDelimiter('submitYodleeTransaction', '#');
        yodleeAutoDefaultConfig.yodleeAutoModal = initScript.getHTMLElementByDelimiter('yodleeAutoModal', '#');
        yodleeAutoDefaultConfig.yodleeBody = (typeof yodleeAutoDefaultConfig.yodleeBody === 'object') ? yodleeAutoDefaultConfig.yodleeBody : JSON.parse(yodleeAutoDefaultConfig.yodleeBody);
        yodleeAutoDefaultConfig.yodlee_error_modal_header = initScript.getHTMLElementByDelimiter('yodlee_error_modal_header');
        appendCSS();
        initScript.getHTMLElementByDelimiter('yodleeManualBtnContinue', '#').click((e) => {
            yodleeManualValidatorSuccess();
        });

        $('input:radio').change(function($event){
            const selectedMethod = $('input[name=yodlee]:checked').val().toString().trim().toLowerCase();
            yodleeAutoDefaultConfig.yodleeManualBtnContinue.css('display', (selectedMethod === 'auto') ? 'none' : 'block');
            yodleeAutoDefaultConfig.yodleeAutoBtnLinkAccount.css('display', (selectedMethod === 'auto') ? 'block' : 'none');
            yodleeAutoDefaultConfig.yodleeAutoBtnLinkContinue.css('display', (selectedMethod === 'auto') ? 'block' : 'none');
            toggleRadioH3Color((selectedMethod === 'auto') ? 0 : 1);
        });

        const toggleRadioH3Color = (selectedMethodIdx) => {
            initScript.getHTMLElementByDelimiter(inputMethods[selectedMethodIdx] + 'DocumentSection h3').addClass(inputMethods[selectedMethodIdx] + 'ActiveSection');
            initScript.getHTMLElementByDelimiter(inputMethods[selectedMethodIdx ^ 1] + 'DocumentSection h3').removeClass(inputMethods[selectedMethodIdx ^ 1] + 'ActiveSection');
        };
        yodleeAutoDefaultConfig.yodleeAutoBtnLinkAccount.on('click', () => {
            hideTermsAndConditionRequiredFieldError();
            yodleeAutoValidator();
        });

        yodleeAutoDefaultConfig.submitYodleeTransaction.on('click', () => {
            initScript.toggleLoader(true);
            const options = initScript.methodWiseOption(yodleeAutoDefaultConfig.options.yodleeTransactionIds.method, {
                url: yodleeAutoDefaultConfig.options.yodleeTransactionIds.url,
                headers: {
                    'x-user-session': yodleeAutoDefaultConfig.yodleeBody['user_token'],
                    ...(yodleeAutoDefaultConfig.yodleeBody['sub'] && { "x-sub": yodleeAutoDefaultConfig.yodleeBody['sub'] }),
                    ...(yodleeAutoDefaultConfig.yodleeBody['sub_id'] && { "x-sub-id": yodleeAutoDefaultConfig.yodleeBody['sub_id'] })
                }
            }, yodleeAutoDefaultConfig.security_option);

            HttpRequest(options, res => {
                initScript.getTargetIdentifierElement('#Failure').innerHTML =  '';
                res = responseV2Interceptor(res, yodleeAutoDefaultConfig.slugs.yodleeTransactionIds);
                res = (!!res && !!res.data) ? res.data : res;
                if (res.code === 400) {
                    initScript.toggleLoader(false);
                    // displayModalHeaderWithMessage((Array.isArray(res.errors)) ? res.errors[0].message : res.errors.message);
                    yodleeAutoDefaultConfig.yodleeAutoModal.innerHTML = '';
                    yodleeAutoDefaultConfig.yodleeAutoModal.css('display', 'none');
                    document.getElementById("Failure").innerHTML = (Array.isArray(res.errors)) ? res.errors[0].message : res.errors.message;
                    initScript.getHTMLElementByDelimiter('Failure', '#').css('display', 'block');
                    cancelYodleeTransaction();
                } else submitYodleeForm(res);
            });
        });

        initScript.getHTMLElementByDelimiter('cancelYodleeTransaction', '#').on('click', () => {
            cancelYodleeTransaction();
        });
    };
    const bindTermsAndConditionEmitters = () => {
        yodleeAutoDefaultConfig.termsAndConditionRequiredFieldError = initScript.getHTMLElementByDelimiter('termsAndConditionRequiredFieldError');
        yodleeAutoDefaultConfig.yodleeManualTermsAndConditionFailure = initScript.getHTMLElementByDelimiter('yodleeManualTermsAndConditionFailure');
        yodleeAutoDefaultConfig.yodleeManualAcceptTermsCondition = initScript.getHTMLElementByDelimiter('yodleeManualAcceptTermsCondition');
        yodleeAutoDefaultConfig.yodleeManualTermsAndConditionSuccess = initScript.getHTMLElementByDelimiter('yodleeManualTermsAndConditionSuccess');
        bindEventsOnClasses();
    };

    /**
     * bindEmitters : binding event emitters
     *
     * @author Nitesh <nitesh.meena@biz2credit.com>
     *
     */
    const bindEventsOnClasses = () => {
        yodleeAutoDefaultConfig.yodleeManualTermsAndConditionFailure.click((e) => {
            hideTermsAndConditionModal();
        });
        yodleeAutoDefaultConfig.yodleeManualAcceptTermsCondition.click((e) => {
            yodleeAutoDefaultConfig.terms_and_condition_accepted = e.target.checked;
        });
        yodleeAutoDefaultConfig.yodleeManualTermsAndConditionSuccess.click((e) => {
            if (yodleeAutoDefaultConfig.terms_and_condition_accepted) {
                hideTermsAndConditionRequiredFieldError();
                yodleeAutoValidatorSuccess();
            }
            else showTermsAndConditionRequiredFieldError();
        });
    };

    /**
     * submitYodleeForm : submit yodlee form
     *
     * @author Nitesh <nitesh.meena@biz2credit.com>
     *
     * @param yodleeTransactionIdsResponse object
     */
    const submitYodleeForm = (yodleeTransactionIdsResponse) => {
        const options = initScript.methodWiseOption(yodleeAutoDefaultConfig.options.submitYodleeForm.method, {
            url: yodleeAutoDefaultConfig.options.submitYodleeForm.url,
            data: JSON.stringify({
                app_id: yodleeAutoDefaultConfig.body.yodleeAuto.app_id,
                user_id: yodleeAutoDefaultConfig.body.yodleeAuto.user_id,
                provider: yodleeAutoDefaultConfig.body.yodleeAuto.provider.auto,
                type: yodleeAutoDefaultConfig.body.yodleeAuto.type || 'bank-statement-auto',
                ref_id: yodleeTransactionIdsResponse['transaction_uid'][0],
                response: yodleeTransactionIdsResponse
            }),
            headers: {
                'Content-Type': 'application/json'
            }
        }, yodleeAutoDefaultConfig.security_option);

        HttpRequest(options, res => {
            classifyDocs(yodleeTransactionIdsResponse);
        });
    };

    /**
     * classifyDocs : classify uploaded docs
     *
     * @author Nitesh <nitesh.meena@biz2credit.com>
     *
     */
    const classifyDocs = (yodleeTransactionIdsResponse) => {
        const data = {
            user_id: yodleeAutoDefaultConfig.body.yodleeAuto.user_id,
            app_id: yodleeAutoDefaultConfig.body.yodleeAuto.app_id,
            provider: {
                auto: yodleeAutoDefaultConfig.body.yodleeAuto.provider.auto,
                manual: yodleeAutoDefaultConfig.body.yodleeAuto.provider['manual']
            }
        };

        const options = initScript.methodWiseOption(yodleeAutoDefaultConfig.options.classifyDocs.method, {
            url: yodleeAutoDefaultConfig.options.classifyDocs.url,
            data: JSON.stringify(data),
            headers: { 'Content-Type': 'application/json' },
            processData: false
        }, yodleeAutoDefaultConfig.security_option);

        HttpRequest(options, (res) => {
            initScript.getTargetIdentifierElement('#doneMessageID').innerHTML = yodleeAutoDefaultConfig.body["success_message"] || 'Thanks for submitting your details, Please close the browser.';
            yodleeAutoDefaultConfig.yodleeAutoModal.innerHTML = '';
            yodleeAutoDefaultConfig.yodleeAutoModal.css('display', 'none');
            initScript.disableElementByProp('#yodleeAutoBtnLinkAccount', true);
            initScript.disableElementByProp('#yodlee_manual', true);
            initScript.disableElementByProp('#yodlee_auto', true);
            initScript.toggleLoader(false);
            cancelYodleeTransaction();
            promiseResolve({
                code: 200,
                type: 'auto',
                status: 'success',
                data: res,
                yodlee_transaction_ids_response: yodleeTransactionIdsResponse
            });
        });
    };

    /**
     * getBankNames : returning bank name's of selected transaction id's
     *
     * @author Nitesh <nitesh.meena@biz2credit.com>
     *
     * @param transaction_ids array
     */
    const getBankNames = transaction_ids => {
        HttpRequest({}, data => {
            //
        });
    };

    /**
     * displayModalHeaderWithMessage : displaying expecting message on modal
     *
     * @author Nitesh <nitesh.meena@biz2credit.com>
     *
     * @param msg string
     */
    const displayModalHeaderWithMessage = (msg) => {
        yodleeAutoDefaultConfig.yodlee_error_modal_header.text(msg);
        yodleeAutoDefaultConfig.yodlee_error_modal_header.css('display', 'block');
    };

    return {
        main,
        widgetPromise
    };

})();
